/** Turns a Graph or token error into a message an administrator can act on. */
export function describeGraphError(error: unknown): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const e: any = error;
  const status: number | undefined = e?.statusCode;
  const message: string = String(e?.message ?? e ?? 'Unknown error');

  if (status === 401 || status === 403 || /AADSTS65001|consent|Authorization_RequestDenied/i.test(message)) {
    return 'SharePoint Organizer does not have permission to read this site yet. A SharePoint administrator ' +
      'needs to upload the app package to the App Catalog and approve the Microsoft Graph "Sites.Read.All" ' +
      'request under SharePoint admin center > Advanced > API access.';
  }
  if (status === 404) {
    return 'The library could not be found. It may have been deleted or renamed.';
  }
  return message;
}
